<!--
  2021-06-18 CHEN PU 修改Landing1和Landing2使用新的文案和按钮
-->
<template>
  <div class="landingPage" :class="$route.name">
    <img class="logo" :src="logo" alt="">
    <!-- <img class="text" :src="text" alt="">-->
    <!-- <div class="download" @click="download" v-if="$route.name==='Landing1'||$route.name==='Landing2'">Download</div>-->

    <div class="ad-text">
        <div>
          <span>{{ $t('lang.landing1.text11') }} </span><span class="ad-text-important">{{ $t('lang.landing1.text12') }}</span>
        </div>
        <div>
          <span>{{ $t('lang.landing1.text21') }} </span><span class="ad-text-important">{{ $t('lang.landing1.text22') }}</span>
        </div>
        <div>
          <span>{{ $t('lang.landing1.text31') }}</span><span class="ad-text-important-1"> {{ $t('lang.landing1.text32') }} </span><span>{{ $t('lang.landing1.text33') }}</span>
        </div>
        <div>
          <span>{{ $t('lang.landing1.text41') }}</span><span class="ad-text-important"> {{ $t('lang.landing1.text42') }} </span><span>{{ $t('lang.landing1.text43') }}</span>
        </div>

        <img class="downloadBtn" :src="btn" alt="" @click="download">

        <img class="paymentLogo" :src="paymentLogo" alt="">
    </div>
  </div>
</template>

<script>
import logo from '@/assets/images/common/logo1.svg'
import paymentLogo from '@/assets/images/common/payment_logo.png'
import btn1 from '@/assets/images/common/landing_button1.gif'
import btn2 from '@/assets/images/common/landing_button2.gif'
import text from '@/assets/images/common/text.png'
export default {
  name: 'Template1',
  data () {
    return {
      logo,
      text,
      btn: '',
      btn1,
      btn2,
      paymentLogo
    }
  },
  mounted () {
    switch (this.$route.name) {
      case 'Landing1':
        this.btn = btn1
        break
      case 'Landing2':
        this.btn = btn2
        break
      case 'Landing3':
        this.btn = btn1
        break
      case 'Landing4':
        this.btn = btn2
        break
    }
  },
  methods: {
    download () {
      const cid = localStorage.getItem('cid') || 'app'
      window.location.href = 'https://api.pgebet.com/mobileapp/pge-' + cid + '-1.2.0.apk'
    }
  }
}
</script>

<style lang="less" scoped>
  .landingPage {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    .logo {
      width: 100px;
      left: 20px;
      top: 20px;
      position: absolute;
    }
    .text {
      bottom: 20%;
    }
    .ad-text{
      font-size: 20px;
      text-align: center;
      color: #F2F2F2;
      position: absolute;
      bottom: 2%;
      margin: 0;
      width: 100%;
      line-height: 35px;
      font-family: Helvetica;
      font-weight: bold;
    }

    .ad-text-important{
      font-weight: bold;
      color: #F6D9AA;
      font-style: italic;
    }

    .ad-text-important-1{
      font-weight: bold;
      color: #ff0202;
      font-style: italic;
    }

  .downloadBtn {
    width: 70%;
  }

  .paymentLogo {
    width: 90%;
    }
  }
  .Landing1 {
  //background: url("../../assets/images/common/landing1.png") center;
    background: url("../../assets/images/common/landing3.png") center;
    background-size: cover;
  }
  .Landing2 {
    //background: url("../../assets/images/common/landing2.png") center;
    background: url("../../assets/images/common/landing4.png") center;
    background-size: cover;
  }
  .Landing3 {
    background: url("../../assets/images/common/landing3.png") center;
    background-size: cover;
  }
  .Landing4 {
    background: url("../../assets/images/common/landing4.png") center;
    background-size: cover;
  }
  .download {
    position: absolute;
    bottom: 11%;
    left: 50%;
    transform: translateX(-50%);
    width: 160px;
    font-size: 20px;
    line-height: 40px;
    color: #F6D9AA;
    border: 1px solid #F6D9AA;
    border-radius: 25px;
    text-align: center;
    -moz-user-select:none;
    -webkit-user-select:none;
    user-select:none;
  }
  .downloadBtn {
    /*position: absolute;
    bottom: 4.5%;*/
  }
</style>



// WEBPACK FOOTER //
// src/pages/Landing/template1.vue